import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import ProductModel from '../../../models/product.model'

const state = {
  products: [],
  kit: new ProductModel() ,
  loading: 0   
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}